import Issue from './Issue'

export default Issue
